import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';
import { CustomFilters } from '../types/types.system';

export const useApiTrace = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const getData = async (filters: CustomFilters[]) => {
    return runApi('Traceability/getData', 'POST', null, filters).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {                
        return res.data;
      }
    });
  };

  return { getData };
};
